import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Hero from "../components/Hero";
import LogoMarquee from "../components/LogoMarquee";
import ProblemSection from "../components/ProblemSection";
import SolutionSection from "../components/SolutionSection";
import WhySection from "../components/WhySection";
import ServicesTeaser from "../components/ServicesTeaser";
import ErfolgeTeaser from "../components/ErfolgeTeaser";
import CreatorBooking from "../components/CreatorBooking";
import ContactSection from "../components/ContactSection";
import TestimonialsStrip from "../components/TestimonialsStrip";
import Reveal from "../components/Reveal";
import SEO from "../components/SEO";

const HomeCTA = () => (
  <section className="py-24 md:py-32 bg-white relative overflow-hidden">
    <div className="max-w-[1100px] mx-auto px-6 md:px-10">
      <Reveal>
        <div className="relative p-10 md:p-16 rounded-[32px] bg-neutral-950 text-white overflow-hidden">
          <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.35),transparent_70%)]" />
          <div className="absolute -bottom-20 -left-20 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(249,115,22,0.25),transparent_70%)]" />
          <div className="relative">
            <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-[-0.03em] leading-[1.02] max-w-3xl">
              Lasst uns eure Marke{" "}
              <span className="bg-gradient-to-r from-pink-400 via-orange-400 to-purple-400 bg-clip-text text-transparent">
                zur ersten Wahl
              </span>{" "}im Feed machen.
            </h2>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/kontakt"
                className="group inline-flex items-center gap-3 px-8 py-5 rounded-full bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 text-white text-sm font-bold tracking-[0.12em] uppercase hover:shadow-[0_18px_42px_-10px_rgba(236,72,153,0.7)] hover:-translate-y-[2px] transition-all duration-300"
              >
                Anfrage senden
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/leistungen"
                className="inline-flex items-center gap-3 px-8 py-5 rounded-full border-2 border-white/20 text-white text-sm font-bold tracking-[0.12em] uppercase hover:bg-white/10 transition-all duration-300"
              >
                Leistungen entdecken
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

const HomePage = () => (
  <>
    <SEO
      title="Social Media Agentur Dortmund"
      description="Performance-Content, UGC & Social Media Strategie für Premium-Brands. Von Aldi bis Five Guys – 8,7 Mio+ Views generiert, 78+ Brands betreut. Kostenloses Erstgespräch."
      path="/"
      keywords="Social Media Agentur, Marketing Agentur, UGC Creator, TikTok Werbung, Instagram Reels, Content Creation, Performance Marketing, Video Produktion, Dortmund, NRW, Deutschland, FREEAYTO"
    />
    <Hero />
    <LogoMarquee />
    <TestimonialsStrip max={2} />
    <ProblemSection />
    <SolutionSection />
    <WhySection />
    <ServicesTeaser />
    <ErfolgeTeaser />
    <CreatorBooking />
    <ContactSection extended={false} />
    <HomeCTA />
  </>
);

export default HomePage;
